<template lang='pug'>
v-row
  v-container.fill-height(fluid v-if="!loggedin")
    v-row(align="center", justify="center")
        v-col(cols="12" sm="8" md="4")
          v-card(class="elevation-12")
            v-toolbar(color="primary" dark flat)
              v-toolbar-title Power Trip Signup
            v-card-text
                v-form(ref="form" v-model="valid" lazy-validation)
                  v-text-field(label="Dealership Name" name="serviceName" prepend-icon="mdi-car" type="text" v-model="serviceName" :rules="[rules.required, rules.minimum]")
                  v-text-field(label="Your Email" name="email" prepend-icon="mdi-account" type="text" v-model="email" autocomplete="username" :rules="[rules.required, rules.email]")
                  v-text-field(
                  id="password"
                  label="Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                  autocomplete="current-password"
                  :rules="[rules.required, rules.minimum]"
                  )
                  v-text-field(
                  id="password"
                  label="Confirm Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="confirmPassword"
                  autocomplete="current-password"
                  :rules="[rules.required, rules.minimum]"
                  )
                v-card-actions
                  v-spacer
                  v-btn(color="primary" @click="signup") Sign Up
    v-snackbar(v-model="snackbar" :timeout="4000") {{ messageText }}
</template>

<script>
export default {
    data() {
        return {
          messageText: "",
          snackbar: false,
          valid: true,
            loggedin: false,
            serviceName: "",
            email: "",
            password: "",
            confirmPassword: "",
                  rules: {
        required: (value) => !!value || "Required.",
        minimum: (value) => value.length >= 3 || "Minimum 3 Characters",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      }
        }
    },
    mounted() {
           localStorage.removeItem("servicecode");
           localStorage.removeItem("credentials");
    },
    methods: {
        async signup() {
            if(this.$refs.form.validate()) {
            var results = await this.$dealer.signup(this.serviceName,this.email,this.password);
          
            if (results.serviceID) {
                this.$serviceCode = results.serviceID;
            localStorage.setItem("servicecode",results.serviceID);
            window.location.href = "/#/dealer";
            window.location.reload();
            } else {
              this.snackbar = true;
              this.messageText = "Unable to create account";
            }
            }
        }
    }
}
</script>